import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../../etiquetado/services/etiquetado.service';
import { AdminService } from '../../../services/admin.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';

@Component({
    selector: 'app-lic-parametros',
    templateUrl: './parametros.component.html'
})
export class LicParametrosComponent implements OnInit, OnDestroy {

    private _licenciaParam;
    private almacenId;
    private paisId;
    private denominacionId;
    public licenciaParams;

    public denominaciones;
    public almacenes;
    public etiquetadores;


    public paramForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public deleteModal = false;

    public toCloseSpinner = 0;

    public dropdownSection: number;
    public pestanaActiva = new Array<number>();

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledAlmacenes: Subject<boolean> = new Subject();
    public disabledEtiquetadores: Subject<boolean> = new Subject();

    public licenciaParamsPaginada;
    private readonly _DEFAULT_ITEMS_PER_PAGE = 3;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;
    public hiddeItems = true;

    private readonly destroy$ = new Subject<void>();

    @Input() licenciaId: number;
    @Input() userName: string;
    @Input() licenciaJunta: boolean;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _dataProvider: DataProvider,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.paramForm = this._fb.group({
            pais: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            etiquetador: [{ value: '', disabled: true }, Validators.required],
            almacen: [{ value: '', disabled: true }, Validators.required]
        });

        this.getLicenciaParams();

        this.paramForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                let filters = {
                    paisId: pais.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getDenominaciones(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        this.disabledDenominaciones.next(false);
                        this.paramForm.get('denominacion').enable();
                    }
                });
            } else {
                this.denominaciones = null;
                this.etiquetadores = null;
                this.almacenes = null;
                this.disabledDenominaciones.next(true);
                this.disabledEtiquetadores.next(true);
                this.disabledAlmacenes.next(true);
                this.paramForm.get('denominacion').reset();
                this.paramForm.get('etiquetador').reset();
                this.paramForm.get('almacen').reset();
            }
        });

        this.paramForm.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                let filters = {
                    paisId: this.paramForm.get('pais').value.id,
                    denominacionId: denominacion.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getEtiquetadores(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.etiquetadores = resp.lista;
                        this.disabledEtiquetadores.next(false);
                        this.paramForm.get('etiquetador').enable();
                    }
                });
            } else {
                this.etiquetadores = null;
                this.almacenes = null;
                this.disabledEtiquetadores.next(true);
                this.disabledAlmacenes.next(true);
                this.paramForm.get('etiquetador').reset();
                this.paramForm.get('almacen').reset();
            }
        });

        this.paramForm.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                let filters = {
                    etiquetadorId: etiquetador.id
                };
                this._spinnerService.showSpinner();
                this.toCloseSpinner += 1;
                this._etiquetadoService.getAlmacenesByEtiquetadorId(filters).toPromise().finally(() => {
                    this.checkCloseSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.almacenes = resp.lista;
                        this.disabledAlmacenes.next(false);
                        this.paramForm.get('almacen').enable();
                        if (this.licenciaParams.find(x => x.desEtiquetador === (this.paramForm.get('etiquetador').value).des)) {
                            this.almacenes = this.almacenes.filter(x => x.des === (this.licenciaParams.find(x => x.desEtiquetador ===
                                    (this.paramForm.get('etiquetador').value).des)).desAlmacen);
                        }
                    }
                });
            } else {
                this.almacenes = null;
                this.disabledAlmacenes.next(true);
                this.paramForm.get('almacen').reset();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get defaultLanguage() {
      return this._translate.getDefaultLang();
    }

    public getLicenciaParams() {
        this._spinnerService.showSpinner();
        this._adminService.getLicenciaParams(this.licenciaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.licenciaParams = resp;
            this.totalItems = this.licenciaParams.length;
            this.licenciaParamsPaginada = this.licenciaParams.slice(this.currentPage, this.itemsPerPage);
        }, (error) => {
            this.showError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public closeDeleteModal() {
        this.deleteModal = false;
    }

    public add() {
        this.checkForm();
        if (this.paramForm.valid) {
            this._licenciaParam = {
                licenciaSwId: this.licenciaId,
                paisId: this.paramForm.get('pais').value.id,
                almacenId: this.paramForm.get('almacen').value.id,
                denominacionId: this.paramForm.get('denominacion').value.id
            };
            this._spinnerService.showSpinner();
            this._adminService.createLicenciaParam(this._licenciaParam).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.showError = true;
                this.mensajes.push({ class: 'success', message: 'global.success.itemCreated' });
                if (resp.userInsId) {
                    this.getLicenciaParams();
                } else {
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            }, (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        }
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._adminService.deleteLicenciaParam(this.licenciaId, this.almacenId, this.denominacionId, this.paisId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.closeDeleteModal();
            this.showError = true;
            this.mensajes.push({ class: 'success', message: 'global.success.itemDeleted' });
            this.getLicenciaParams();
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public askDelete(param) {
        this.licenciaId = param.licenciaSwId;
        this.almacenId = param.almacenId;
        this.paisId = param.paisId;
        this.denominacionId = param.denominacionId;
        this.deleteModal = true;
    }

    private checkForm() {
        this.showError = this.paramForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    public pushMessage(mensaje) {
        this.showError = true;
        if (mensaje.includes('error') || mensaje.includes('ApiErrors')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public openTabs(i) {
        this.dropdownSection = this.dropdownSection === i ? -1 : i;
        this.pestanaActiva[i] = this.pestanaActiva[i] > 0 ? this.pestanaActiva[i] : 1;
        if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
            setTimeout(() => {
                document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
            }, 50);
        }
    }

    public showGrupoEtiquetaDenominacion(i) {
        this.pestanaActiva[i] = 1;
    }

    public showGrupoEtiquetaMarca(i) {
        this.pestanaActiva[i] = 2;
    }

    public showCertificado(i) {
        this.pestanaActiva[i] = 3;
    }

    public trackByParam(_index: number, param: any): string {
        return `${param.licenciaSwId}-${param.paisId}-${param.almacenId}-${param.denominacionId}`;
    }

    public toRefresh(value) {
        if (value) {
          this.getLicenciaParams();
        }
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.licenciaParamsPaginada = this.licenciaParams.slice(this.itemsPerPage * this.currentPage, (this.itemsPerPage * this.currentPage) + this.itemsPerPage);
      }
}
